import DefaultError from "@ext/errorHandlers/logic/DefaultError";

export enum AgentErrorType {
	Unauthorized = "unauthorized",
	Forbidden = "forbidden",
	PaymentRequired = "payment_required",
	BalanceExhausted = "balance_exhausted",
	MaxStepsExceeded = "max_steps_exceeded",
	NetworkError = "network_error",
	EmptyResponse = "empty_response",
	Unexpected = "unexpected",
}

export enum AgentWarningType {
	CacheHitZero = "cache_hit_zero",
}

export class AgentError extends DefaultError {
	readonly errorType: AgentErrorType;
	readonly status?: number;

	constructor(errorType: AgentErrorType, message: string, status?: number) {
		super(message, undefined, { errorType });
		this.name = "AgentError";
		this.errorType = errorType;
		this.status = status;
	}
}

export function isAgentError(error: unknown): error is AgentError {
	return error instanceof AgentError;
}
